export default {
    OrganismosDeBase: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "organizacao-de-base"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/OrganismosDeBase.js
// module id = 5cvK
// module chunks = 13